import React, { memo } from 'react'
import { useTheme } from '@material-ui/core/styles'

import Typography from '../display/typography'

import useStyles from './balloonTimeStyle'

const BalloonTime = (props) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <>
      <div
        style={{
          display: 'flex',
          flex: 'auto 1 auto',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: 30,
          marginBottom: 20,
        }}
      >
        <div
          style={{
            borderBottom: `1px solid ${theme.palette.divider}`,
            width: '100%',
          }}
        ></div>
        <div style={{ width: 15 }} />
        <div className={classes.dividerText}>
          <Typography variant="body1">{props.time}</Typography>
        </div>
        <div style={{ width: 15 }} />
        <div
          style={{
            borderBottom: `1px solid ${theme.palette.divider}`,
            width: '100%',
          }}
        ></div>
      </div>
    </>
  )
}

export default memo(BalloonTime)
